<template>
    <b-button
      type="button"
      size="sm"
      variant="primary"
      v-on:click="addUser"
    >
      <i class="fa fa-plus" ></i> Add
    </b-button>
</template>
<script>
    import {RepositoryFactory} from "../../../services/repositories/RepositoryFactory";
    import {handleErrors} from "../../../shared/utils";
    import {User} from "../../../models/User";
    import router from "../../../router";

    const UserRepo = RepositoryFactory.get('user');

    export default {
        name: 'user-add-button',
        props: {
            user: {
                type: Object,
                default: new User(),
            },
        },
        methods: {
            addUser() {
                this.$emit('click')
                UserRepo
                    .createUser(
                        {
                            name: this.user.name,
                            surname: this.user.surname,
                            email: this.user.email,
                            password: this.user.password
                        }
                    )
                    .then(
                        response =>
                            (
                                router.push({name: 'user', params: {userId: response.data.data.id}})
                            )
                    )
                    .catch(
                        response => (
                            this.returnErrors(response)
                        )
                    )
            },
            returnErrors(response) {
                this.$emit('click')
                handleErrors(response).forEach(
                    value => {
                        this.flash(value,'error')
                    }
                )
            },
        },
    }
</script>
